import { Flex, FlexProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'

export type FlexBoxWidgetProps = FlexProps

export const FlexBoxWidget = ({ children, ...props }: FlexBoxWidgetProps) => {
  return <Flex {...props}>{children}</Flex>
}

export const FlexBoxWidgetDefinition = createWidget(FlexBoxWidget, {
  type: 'FlexBox',
})
